<template>
<base-auth>
<div v-if="!has_two_factor_auth" class="kt-login__form">
    <div class="alert alert-danger" v-if="message">
        {{message}}
    </div>
  <form class="kt-form" @submit.prevent="onSubmit">
    <vue-recaptcha
        v-if="captchaDriver === 'recaptcha'"
        ref="invisibleRecaptcha"
        @verify="onVerify"
        @expired="onExpired"
        size="invisible"
        :sitekey="sitekey"
        :loadRecaptchaScript="true">
    </vue-recaptcha>

    <arcaptcha-vue
        v-if="captchaDriver === 'arcaptcha'"
        ref="arcaptcha"
        key="login-captcha"
        :site_key="arCaptchaKey"
        :invisible="true"
        :callback="onArcaptchaSuccess"
        :expired_callback="onArcaptchaExpired"
        :error_callback="onArcaptchaError"
    />

    <kt-form-group>
        <kt-form-control
            v-bind:placeholder="$t('auth.placeholder.outh_param')"
            name="outh_param" autocomplete="off"
            v-model="outh_param"
        ></kt-form-control>
    </kt-form-group>
    <kt-form-group>
        <kt-form-control
            type="password"
            is_last
            v-bind:placeholder="$t('auth.placeholder.pass')"
            name="password"
            autocomplete="off"
            v-model="password"
              />
    </kt-form-group>
    <div class="kt-login__extra">
        <kt-form-check name="remember" v-model="remember">
            {{ $t('auth.remember_me') }}
        </kt-form-check>
        <router-link id="kt_login_forgot" to="/forget-pass">
            {{ $t('auth.forget_pass') }}
        </router-link>
    </div>
    <div class="kt-login__actions">
        <kt-button type="submit" id="kt_login_signin_submit" variant="brand" class="btn-pill btn-elevate">
            {{ $t('auth.btn.sign_in') }}
        </kt-button>
    </div>
  </form>
</div>
  <div v-if="!has_two_factor_auth" class="kt-login__account">
<!--    <span class="kt-login__account-msg">-->
<!--        {{ $t('auth.not_registered_yet') }}-->
<!--    </span>&nbsp;&nbsp;-->
<!--    <router-link to="/register" class="kt-login__account-link">-->
<!--        {{ $t('auth.btn.sign_up') }}-->
<!--    </router-link>-->
  </div>
  <div v-if="has_two_factor_auth" class="kt-login__form">
        <form class="kt-form border border-dark rounded-lg p-4" @submit.prevent="onSubmitVerify" v-if="two_factor_type == 1">
                <vue-recaptcha
                    v-if="captchaDriver === 'recaptcha'"
                    ref="invisibleRecaptchaVerify"
                    @verify="onVerifyForAuth"
                    @expired="onExpiredVerify"
                    size="invisible"
                    :sitekey="sitekey"
                    :loadRecaptchaScript="true">
                </vue-recaptcha>

                <arcaptcha-vue
                    v-if="captchaDriver === 'arcaptcha'"
                    ref="arcaptchaVerify"
                    key="verify-captcha"
                    :site_key="arCaptchaKey"
                    :invisible="true"
                    :callback="onArcaptchaVerifySuccess"
                    :expired_callback="onArcaptchaVerifyExpired"
                    :error_callback="onArcaptchaVerifyError"
                />

                <kt-form-group>
                    <kt-form-control
                        v-bind:placeholder="$t('auth.placeholder.outh_param')"
                        name="outh_param" autocomplete="off"
                        disabled
                        :value="phone"
                    ></kt-form-control>
                </kt-form-group>
                <kt-form-group>
                    <kt-form-control
                        type="text"
                        v-bind:placeholder="$t('label.verify_code')"
                        name="code"
                        autocomplete="off"
                        class="form-control"
                        v-model="verify_code"
                    />
                </kt-form-group>

            <div class="kt-login__actions">
                <kt-button type="submit" id="submit_code" variant="brand" class="btn-pill btn-elevate">
                    {{ $t('auth.btn.sign_in') }}
                </kt-button>
            </div>

            <div class="kt-login__account" v-if="counter==false">
                    <span class="kt-login__account-msg">
                        {{ $t('auth.not_recived') }}
                    </span>&nbsp;&nbsp;
                <button class="btn btn-link p-0 m-0" id="resend_btn" @click="sendVerify">
                    {{ $t('auth.btn.resend') }}
                </button>
            </div>
            <div class="kt-login__account" v-if="counter==true">
                    <span class="kt-login__account-msg">
                      <span class="bg-white p-0 m-0">
                        {{ $t('auth.code_not_received') }}
                      </span>
                      {{ message2 }}
                    </span>
            </div>
          <div class="my-3">
            <button
                class="btn btn-link p-0 m-0"
                v-if="is_g2fa_active"
                @click.prevent="verifyWithG2fa"
            >
              {{ $t('auth.btn.login_with_google_two_factor') }}
            </button>
          </div>

        </form>

        <form
            id="g2fa-form"
            class="kt-form border border-dark rounded-lg p-4"
            @submit.prevent="onSubmitVerifyG2fa"
            v-if="two_factor_type == 2"
        >
          <vue-recaptcha
              v-if="captchaDriver === 'recaptcha'"
              ref="invisibleRecaptchaVerifyG2fa"
              @verify="onVerifyForG2fa"
              @expired="onExpiredVerifyG2fa"
              size="invisible"
              :sitekey="sitekey"
              :loadRecaptchaScript="true">
          </vue-recaptcha>

          <arcaptcha-vue
              v-if="captchaDriver === 'arcaptcha'"
              ref="arcaptchaVerifyG2fa"
               key="verify-captcha-g2fa"
              :site_key="arCaptchaKey"
              :invisible="true"
              :callback="onArcaptchaG2faSuccess"
              :expired_callback="onArcaptchaG2faExpired"
              :error_callback="onArcaptchaG2faError"
          />

          <kt-form-control
              v-bind:placeholder="$t('auth.login.google_authenticator_code')"
              name="google_authenticator_code"
              class="text-center"
              autocomplete="off"
              v-model="google_authenticator_code"
              type="text"
              id="google_authenticator_code"
              dir="ltr"
          />

          <div class="kt-login__actions">
            <kt-button type="submit" id="g2fa-btn" variant="brand" class="btn-pill btn-elevate">
              {{ $t('auth.btn.sign_in') }}
            </kt-button>
          </div>

          <div class="my-3" v-if="counter==false">
            <button class="btn btn-link p-0 m-0" id="resend_btn"  @click="sendVerify">
              {{ $t('auth.btn.login_with_sms_two_factor') }}
            </button>
          </div>

          <div class="kt-login__account" v-if="counter==true">
                    <span class="kt-login__account-msg">
                      {{ message3 }}
                    </span>
          </div>
        </form>
  </div>

</base-auth>
</template>

<script>
import baseAuth from '@/components/base-auth'
import $ from 'jquery'
import VueRecaptcha from 'vue-recaptcha'
import { reCaptchaKeys } from '@/constants/getRecaptchaKey'
import { arCaptchaKeys } from '@/constants/getArCaptchaKey'
import { getCaptchaDriver } from '@/constants/getCaptchaDriver'
import {KTApp} from "@/plugins/core/app";
import {i18n} from "@/plugins/i18n";
import toastr from "toastr";
import Inputmask from "inputmask";
import ArcaptchaVue from 'arcaptcha-vue'

export default {
    data() {
        return {
          remember: false,
          outh_param: '',
          password: '',
          login_event: null,
          recaptcha_verified: false,
          recaptcha_verify: false,
          g_recaptcha_response: '',
          sitekey: reCaptchaKeys,
          arCaptchaKey: arCaptchaKeys,
          captchaDriver: getCaptchaDriver,
          has_two_factor_auth: false,
          verify_code:null,
          phone: '',
          timer: 180,
          message: "",
          message2: "",
          message3: "",
          g2fa_message: "",
          counter: false,
          interval: null,
          two_factor_type: null,
          is_g2fa_active: null,
          google_authenticator_code: null,
          arcaptchaToken: '',
          arcaptchaVerified: false,
        }
    },
    components: {
      'base-auth': baseAuth,
      'vue-recaptcha': VueRecaptcha,
      ArcaptchaVue,
    },
    computed: {
      toastr() {
        toastr.options = {
          closeButton: true,
          positionClass: "toast-bottom-center",
          preventDuplicates: false,
          rtl: false
        }

        return toastr
      },
    },
    methods: {
        onSubmit: function (e) {
          this.message = "";
          let form = $(e.target);

          form.validate({
            lang: 'fa',
            rules: {
                password: {
                    required: true
                },
                outh_param: {
                    required: true
                }
            }
          });

          if (!form.valid()) {
            return;
          }

          this.login(e);
        },

        executeCaptcha() {
          if (this.captchaDriver === 'recaptcha') {
            this.$refs.invisibleRecaptcha.execute();
          } else if (this.captchaDriver === 'arcaptcha') {
            this.arcaptchaVerified = false;
            this.arcaptchaToken = '';
            this.$refs.arcaptcha.execute();
          }
        },

        executeCaptchaForVerify() {
            if (this.captchaDriver === 'recaptcha') {
                this.$refs.invisibleRecaptchaVerify.execute();
            } else if (this.captchaDriver === 'arcaptcha') {
                this.$refs.arcaptchaVerify.execute();
            }
        },

        executeCaptchaForG2fa() {
          if (this.captchaDriver === 'recaptcha') {
            this.$refs.invisibleRecaptchaVerifyG2fa.execute();
          } else if (this.captchaDriver === 'arcaptcha') {
            this.$refs.arcaptchaVerifyG2fa.execute();
          }
        },

        onArcaptchaSuccess(token) {
            this.arcaptchaToken = token
            this.arcaptchaVerified = true
            this.login(this.login_event)
        },

        onArcaptchaExpired() {
            this.arcaptchaVerified = false;
            this.arcaptchaToken = '';
        },

        onArcaptchaError(error) {
            this.arcaptchaVerified = false;
            this.arcaptchaToken = '';
            this.showMsg($('.kt-form'), 'danger', 'Captcha verification failed. Please try again.');
        },

        onArcaptchaVerifySuccess(token) {
            this.arcaptchaToken = token;
            this.arcaptchaVerified = true;
            this.verify();
        },


        onArcaptchaVerifyExpired() {
            if (this.arcaptchaTimeout) {
                clearTimeout(this.arcaptchaTimeout);
                this.arcaptchaTimeout = null;
            }
            this.arcaptchaVerified = false;
            this.arcaptchaToken = '';
            this.is_submitting_verify = false;
            this.showMsg($('.kt-form'), 'danger', 'Captcha expired. Please try again.');
        },

        onArcaptchaVerifyError(error) {
            if (this.arcaptchaTimeout) {
                clearTimeout(this.arcaptchaTimeout);
                this.arcaptchaTimeout = null;
            }
            this.handleArCaptchaFailure();
        },


        onArcaptchaG2faSuccess(token) {
            this.arcaptchaToken = token;
            this.arcaptchaVerified = true;
            if (this.google_authenticator_code) {
                this.verifyG2fa(this.login_event);
            }
        },

        onArcaptchaG2faExpired() {
            this.arcaptchaVerified = false;
            this.arcaptchaToken = '';
        },

        onArcaptchaG2faError(error) {
        },

        resetCaptcha() {
            if (this.captchaDriver === 'recaptcha') {
                this.$refs.invisibleRecaptcha && this.$refs.invisibleRecaptcha.reset();
            } else if (this.captchaDriver === 'arcaptcha') {
                this.$refs.arcaptcha && this.$refs.arcaptcha.reset();
                this.arcaptchaVerified = false;
                this.arcaptchaToken = '';
            }
        },

        resetCaptchaVerify() {
            if (this.captchaDriver === 'recaptcha') {
                this.$refs.invisibleRecaptchaVerify && this.$refs.invisibleRecaptchaVerify.reset();
            } else if (this.captchaDriver === 'arcaptcha') {
                this.$refs.arcaptchaVerify && this.$refs.arcaptchaVerify.reset();
                this.arcaptchaVerified = false;
                this.arcaptchaToken = '';
            }
        },

        resetCaptchaVerifyG2fa() {
            if (this.captchaDriver === 'recaptcha') {
                this.$refs.invisibleRecaptchaVerifyG2fa && this.$refs.invisibleRecaptchaVerifyG2fa.reset();
            } else if (this.captchaDriver === 'arcaptcha') {
                this.$refs.arcaptchaVerifyG2fa && this.$refs.arcaptchaVerifyG2fa.reset();
                this.arcaptchaVerified = false;
                this.arcaptchaToken = '';
            }
        },

        isCaptchaVerified() {
            if (this.captchaDriver === 'recaptcha') {
                return this.recaptcha_verified;
            } else if (this.captchaDriver === 'arcaptcha') {
                return this.arcaptchaVerified && this.arcaptchaToken;
            }
            return false;
        },

        getCaptchaResponse() {
            if (this.captchaDriver === 'recaptcha') {
                return this.g_recaptcha_response;
            } else if (this.captchaDriver === 'arcaptcha') {
                return this.arcaptchaToken;
            }
            return '';
        },

        onSubmitVerify: async function (e) {
            this.is_submitting_verify = true;
            this.arcaptchaVerified = false;
            this.arcaptchaToken = '';
            if (this.captchaDriver === 'arcaptcha') {
              await this.$refs.arcaptchaVerify.reset();
              await this.$refs.arcaptchaVerify.execute();
            } else {
              this.executeCaptchaForVerify();
            }
        },


        onSubmitVerifyG2fa: function (e) {
            let form = $('#g2fa-form');
            form.validate({
                ignore: ".ignore",
                rules: {
                    google_authenticator_code: {
                        required: true,
                    },
                },
            });

            if (!form.valid()) {
                return;
            }

            this.login_event = e;
            this.resetCaptchaVerifyG2fa();
            this.executeCaptchaForG2fa();
        },

        onVerifyForAuth: function (response) {
            this.arcaptchaVerified = true;
            this.recaptcha_verify = true;
            this.g_recaptcha_response = response;
            this.verify()
        },

        onVerifyForG2fa: function (response) {
            this.recaptcha_verify = true;
            this.g_recaptcha_response = response;
            if (this.google_authenticator_code) {
                this.verifyG2fa(this.login_event);
            }
        },

        onVerify: function (response) {
            this.recaptcha_verified = true;
            this.g_recaptcha_response = response;
            this.login(this.login_event);
        },
        onExpired: function () {
            this.recaptcha_verified = false;
        },
        onExpiredVerify: function () {
            this.recaptcha_verify = false;
        },

        onExpiredVerifyG2fa: function () {
            this.recaptcha_verify = false;
        },
        login (e) {
            this.message= "";
            let form = $(e.target);
            let btn = $('#kt_login_signin_submit')

            form.validate({
              lang: 'fa',
              rules: {
                  password: {
                      required: true
                  },
                  outh_param: {
                      required: true
                  }
              }
            });

            if(!form.valid()) {
              return
            }

            // if (!this.isCaptchaVerified()) {
            //     return;
            // }

            let params = {
              remember: this.remember,
              outh_param: this.outh_param,
              password: this.password,
              verfy_url: this.$url('verify'),
            }

            // if (this.captchaDriver === 'recaptcha') {
            //     params['g-recaptcha-response'] = this.g_recaptcha_response;
            // } else if (this.captchaDriver === 'arcaptcha') {
            //     params['g-recaptcha-response'] = this.arcaptchaToken;
            // }

            btn
              .addClass('kt-spinner kt-spinner--right kt-spinner--sm kt-spinner--light')
              .attr('disabled', true)

            this.$store.dispatch('auth/login', params)
            .then(
                response => {
                    form.find('.alert').remove()
                    if (!response.has_two_factor_auth) {
                        window.location.replace(this.$url(""));
                      return true;
                    }

                    setTimeout(() => {
                      document.getElementById("google_authenticator_code") &&
                      Inputmask("9     9     9     9     9     9").mask(document.getElementById("google_authenticator_code"));
                    }, 100);

                    this.has_two_factor_auth = true;
                    this.phone = response.phone;
                    this.two_factor_type = response.two_factor_type
                    this.is_g2fa_active = response.is_g2fa_active

                    if (this.two_factor_type == 1) {
                      this.toastr.success(i18n.t('auth.code.sent'))
                      this.sendVerifyStatus
                      this.startTimer()
                    }
                },
                error => {
                    btn
                        .removeClass('kt-spinner kt-spinner--right kt-spinner--sm kt-spinner--light')
                        .attr('disabled', false)

                        this.resetCaptcha();

                    if (error.data.tag == 'passwordChangeRequired') {
                        // Redirect to the password change page
                        sessionStorage.setItem('passwordChangeMessage', this.$t('auth.90_days_password_cycle'));
                        this.$router.push({ path: '/forget-pass'});
                        return;
                    }

                    if (error.data.status === 429) {
                        console.log(error)
                        this.message = error.data.message;
                        this.sendVerifyStatus
                        this.startTimer()
                        return;
                    }
                    if(error.data) {
                        form.validate().showErrors(error.data.data)
                    }
                    btn
                        .removeClass('kt-spinner kt-spinner--right kt-spinner--sm kt-spinner--light')
                        .attr('disabled', false)

                    this.showMsg(form, 'danger', error.data.message)
                    this.recaptcha_verified = false
                    this.resetCaptcha()

                    if (error.data.status === 429) {
                        this.sendVerifyStatus
                        this.startTimer()
                    }
                }
            )
            .finally(() => {
              btn
                  .removeClass('kt-spinner kt-spinner--right kt-spinner--sm kt-spinner--light')
                  .attr('disabled', false)
            })
        },
        verifyWithG2fa() {
          if(this.is_g2fa_active) {
            this.two_factor_type = 2

            setTimeout(() => {
              document.getElementById("google_authenticator_code") &&
              Inputmask("9     9     9     9     9     9").mask(document.getElementById("google_authenticator_code"));
            }, 100);

            return;
          }

          this.toastr.error('Google Authenticator برای شما فعال نمیباشد.')
        },
        verifyG2fa() {
          let form = $('#g2fa-form')
          let btn = $('#g2fa-btn')

          form.validate({
            ignore: ".ignore",
            rules: {
              google_authenticator_code: {
                required: true,
              },
            },
          });

          if (!form.valid()) {
            return;
          }


          let params = {
            phone: this.phone,
            google_authenticator_code: this.google_authenticator_code.replace(/\s+/g, ''),
          }

          if (this.captchaDriver === 'recaptcha') {
              params['g-recaptcha-response'] = this.g_recaptcha_response;
          } else if (this.captchaDriver === 'arcaptcha') {
              params['g-recaptcha-response'] = this.arcaptchaToken;
          }

          KTApp.progress(btn)

           if (this.captchaDriver === 'recaptcha') {
                params['g-recaptcha-response'] = this.g_recaptcha_response;
            } else if (this.captchaDriver === 'arcaptcha') {
                params['g-recaptcha-response'] = this.arcaptchaToken;
            }

          this.is_login_pending = true

          this.$store.dispatch('auth/verifyG2faForLogin', params).then(
              (response) => {
                window.location.replace(this.$url(""));
              },
              (error) => {
                  this.showMsg(form, 'danger', error.message)
                  if(error.data && error.data.length > 0) {
                      form.validate().showErrors(error.data.data)
                  }
                this.resetCaptchaVerify()
              }
          ).finally(() => {
              this.is_login_pending = false;
              KTApp.unprogress(btn);
          })
        },
        verify(e) {
            let form;
            if (e && e.target) {
                form = $(e.target);
            } else {
                form = $('.kt-form').last();
            }

            let btn = $("#submit_code");

            form.validate({
                lang: "fa",
                rules: {
                    code: {
                        required: true,
                    },
                },
            });

            if (!form.valid()) {
                this.is_submitting_verify = false;
                return;
            }

            KTApp.progress(btn);

            let params = {
                code: this.verify_code,
                phone: this.phone,
            };

            if (this.captchaDriver === 'recaptcha') {
                params['g-recaptcha-response'] = this.g_recaptcha_response || '';
            } else if (this.captchaDriver === 'arcaptcha') {
                params['g-recaptcha-response'] = this.arcaptchaToken;
            }

            this.is_login_pending = true;

            this.$store.dispatch("auth/verifyForLogin", params).then(
                (response) => {
                    this.is_login_pending = false;
                    window.location.replace(this.$url(""));
                },
                (error) => {
                    KTApp.unprogress(btn);
                    console.error('Verify request failed:', error);

                    if (error.data && error.data.data && error.data.data['g-recaptcha-response']) {
                        console.error('Captcha validation failed on server');
                        this.showMsg(form, 'danger', 'Security verification failed. Please try again.');
                        this.resetCaptchaVerify();
                    } else {
                        if (error.data && error.data.data) {
                            form.validate().showErrors(error.data.data);
                        }
                        this.toastr.error(error.message || 'Verification failed');
                    }

                    this.recaptcha_verified = false;
                }
            ).finally(() => {
                this.is_login_pending = false;
                this.is_submitting_verify = false;
            });
        },
        sendVerify(e) {
            let btn = $(e.target)
            let form = $('.kt-form')

            let params = {
                phone: this.phone,
            }

            KTApp.progress(btn)
            this.$store.dispatch('auth/sendVerify', params)
                .then(response => {
                    this.two_factor_type = 1
                    this.showMsg($('.kt-form'), 'success', response.message)
                    this.sendVerifyStatus
                    this.startTimer()
                    this.timer = 180;
                })
                .catch(response => {
                    if (response.data) {
                        form.validate().showErrors(response.data)
                    }
                    this.showMsg($('.kt-form'), 'danger', response.message)
                })
                .finally(() => {
                    KTApp.unprogress(btn)
                })
        },

        startTimer() {
            this.interval = setInterval(this.countDown, 1000);
        },

        countDown() {
            var n = this.timer
            if (!this.counter) {
                this.counter = true;
            } else if (n > 0) {
                n = n - 1
                this.timer = n
                let minute = parseInt(n % 60)
                let second = parseInt(n / 60)
                this.message2 = `ارسال مجدد کد${this.pad(second)}:${this.pad(minute)} دیگر `
                this.message3 = `درخواست ورود از طریق پیامک${this.pad(second)}:${this.pad(minute)}  دیگر `
            } else {
                clearInterval(this.interval);
                this.counter = false
                this.message2 = ""
            }
        },

        pad(num) {
            return num.toString().padStart(2, '0');
        },

        showMsg(form, type, message) {
            if (type === 'danger') {
                this.message = message;
            } else {
                this.toastr[type](message);
            }
        }
    }
}
</script>
